export default __webpack_public_path__ + "static/media/mapa_web.98e4c068.png";